<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-13 13:30:52
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2022-07-11 15:12:36
 * @Description: 图片上传插件
 * @FilePath: /hsylc2021/src/components/form/Uploader/ImageUploader/index.vue
-->
<template>
  <div class="component-image-uploader" :class="computedClass">
    <div class="uploader-wrap" v-show="state === STATE.READY || state === STATE.SUCCESS">
      <input type="file" ref="file" class="_uploader" v-show="!disabled" :accept="acceptTypeStr" @change="handleFileChange" />
      <div class="loader-content">
        <div class="ready-content" v-show="state === STATE.READY">
          <i class="i-image"></i>
          <p class="t-ct w-bold color-17181A fs-16 mt-10" v-html="placeholder"></p>
        </div>
        <component-image className="lazy-loader" v-show="state === STATE.SUCCESS" v-if="value && value.url" type="bg" :src="previewUrl" />
      </div>
    </div>
    <div class="uploader-wrap" v-show="state === STATE.LOAD">
      <div class="loader-content">
        <div class="c-loader"></div>
      </div>
    </div>
    <div class="uploader-wrap" v-show="state === STATE.ERROR" @click="showReady">
      <div class="loader-content">
        <div class="error-content">
          <Close color="#E61717" width="20px" className="close-wrap" />
          <p class="t-ct w-normal color-E61717 fs-16 mt-10">上传失败 请重新上传</p>
        </div>
        <i class="i-reverse"></i>
      </div>
    </div>
  </div>
</template>
<script>
import Image from '../../../Image';
import { Close } from '../../../icons';
import { Codes } from '../../../../api';
import UPLOAD_TYPE from '../uploadType';
import ACCEPT_TYPES from '../acceptTypes';
import ROLES from '../../../../utils/roles';
import { withCacheBust } from 'utils/ossFileUrl';
import UTILS from '../utils';
const STATE = {
  READY: 'READY',
  LOAD: 'LOAD',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};
/**
 * 图片上传组件
 * @module ImageUploader
 */
export default {
  name: 'ImageUploader',
  /**
   * @prop {Component} Close 打岔图标
   * @prop {Component} Image 图片懒加载组件
   */
  components: {
    Close,
    'component-image': Image
  },
  /**
   * @prop {Number} maxSize 最大大小
   * @prop {String} sizeType 尺寸类型 默认mb
   * @prop {String} className 外部class
   * @prop {String} type 上传类型 默认album
   * @prop {Object} value 组件数据
   * @prop {Boolean} disabled 是否禁用 默认false
   * @prop {String} role 组件使用者类型 默认student
   */
  props: {
    maxSize: {
      type: Number,
      default: 0
    },
    sizeType: {
      type: String,
      default: 'mb'
    },
    className: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: UPLOAD_TYPE.ALBUM
    },
    value: {
      type: Object,
      default: function() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '上传图片'
    },
    role: {
      type: String,
      default: ROLES.STUDENT
    },
    acceptType: {
      type: Array,
      default: () => ['jpeg', 'png', 'jpg']
    }
  },
  watch: {
    state(state) {
      switch (state) {
        case STATE.READY:
          this.$emit('ready');
          break;
        case STATE.LOAD:
          this.$emit('load');
          break;
        case STATE.SUCCESS:
          this.$emit('success');
          break;
      }
    }
  },
  /**
   * @prop {Object} computedClass 计算后的组件class
   * @prop {String} acceptTypeStr 传入input具体accept
   * @prop {Object} STATE 组件所有状态
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      ret['disabled'] = this.disabled;
      return ret;
    },
    STATE() {
      return STATE;
    },
    acceptTypeStr() {
      return UTILS.getAcceptTypeStr(this.acceptType);
    },
    /**
     * 预览用 bust URL；value.url 仍保持干净。
     * @returns {string}
     */
    previewUrl() {
      return withCacheBust(this.value && this.value.url);
    }
  },
  /**
   * @prop {String} state 组件状态
   * @prop {String} file 文件
   */
  data: () => ({
    state: STATE.READY,
    file: null
  }),
  created: function() {
    if (this.value && (this.value.url || this.value.name)) {
      this.state = STATE.SUCCESS;
    } else {
      this.showReady();
    }
  },
  methods: {
    /**
     * @event input v-model绑定事件
     */
    /**
     * @description 文件变化事件
     * @function handleFileChange
     */
    handleFileChange: async function(e) {
      if (e.target.files && e.target.files.length) {
        this.file = e.target.files[0];
        this.state = STATE.LOAD;
        let res = await UTILS.uploadFile(this.file, this.type, this.maxSize, this.sizeType, this.role);
        if (res.status === Codes.SUCCESS) {
          this.state = STATE.SUCCESS;
          this.$emit('input', {
            name: this.file.name,
            url: res.data.url
          });
        } else {
          this.showErr(res.msg);
        }
      }
    },
    /**
     * @event input v-model绑定事件
     */
    /**
     * @description 切换为准备状态
     * @function showReady
     */
    showReady: function() {
      this.$emit('input', {});
      this.file = null;
      if (this.$refs.file) {
        this.$refs.file.value = '';
      }
      this.state = STATE.READY;
    },
    /**
     * @event error 错误钩子
     */
    /**
     * @description 切换为错误状态
     * @function showErr
     * @param {String} msg 错误信息
     */
    showErr: function(msg) {
      this.state = STATE.ERROR;
      this.errMsg = msg;
      this.$emit('error', msg);
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
